import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/reservation`;

export const getReservation = (statusInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation`,
  body: statusInfo
});

export const getReservationTypeList = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-type-list`
});

export const getReservationTimeList = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-time-list`
});

export const updateReservation = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update`,
  body: updateInfo
});

// 未綁定顧客

export const getUnbindReservation = (statusInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/unbind/get-reservation`,
  body: statusInfo
});
